export default function UnauthorizedRedirect(personinfo, persontype, navigate = null) {
    const redirect = (path) => {
        if (navigate) {
            navigate(path, { replace: true });
        } else {
            window.location.replace(path);
        }
    };

    const isPersonTypeArray = Array.isArray(persontype);
    if (isPersonTypeArray) {
        if (persontype.includes('All') || !persontype.includes(personinfo.personType)) {
            redirect('/un-authorized');
            return;
        }
    } else {
        if (persontype !== 'All' && personinfo.personType !== persontype) {
            redirect('/un-authorized');
            return;
        }
    }
}
